
import { Component, Vue, Mixins, Prop } from 'vue-property-decorator'
import Chart from '../../mixins/Chart.vue'
import { Dataset, Options } from '../../@types/Slide'

@Component
export default class Area extends Mixins(Chart) {
  /**
   * Chart type.
   */
  public readonly chartType: string = 'area'
}
